import { request } from '../request';

/** Multi-agent management API (CoPaw v0.1+ `/agents` routes). */
export const agentsManagementApi = {
  listAgents: () => request('/agents'),

  getAgent: (agentId) => request(`/agents/${agentId}`),

  createAgent: (body) =>
    request('/agents', {
      method: 'POST',
      body: JSON.stringify(body)
    }),

  updateAgent: (agentId, body) =>
    request(`/agents/${agentId}`, {
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  deleteAgent: (agentId) =>
    request(`/agents/${agentId}`, {
      method: 'DELETE'
    }),

  reorderAgents: (agentIds) =>
    request('/agents/order', {
      method: 'PUT',
      body: JSON.stringify({ agent_ids: agentIds })
    }),

  toggleAgentEnabled: (agentId, enabled) =>
    request(`/agents/${agentId}/toggle`, {
      method: 'PATCH',
      body: JSON.stringify({ enabled })
    }),

  listAgentFiles: (agentId) => request(`/agents/${agentId}/files`),

  readAgentFile: (agentId, filename) => request(`/agents/${agentId}/files/${encodeURIComponent(filename)}`),

  writeAgentFile: (agentId, filename, content) =>
    request(`/agents/${agentId}/files/${encodeURIComponent(filename)}`, {
      method: 'PUT',
      body: JSON.stringify({ content })
    }),

  listAgentMemory: (agentId) => request(`/agents/${agentId}/memory`),

  /** Skills bound to a multi-agent instance (optional; falls back to agent profile `skills` if 404). */
  listAgentSkills: (agentId) => request(`/agents/${agentId}/skills`)
};
